import { GridColDef, GridEditInputCell, GridPreProcessEditCellProps } from "@mui/x-data-grid"
import { Box } from "@mui/material"
import EditableTable from "@components/EditableTable"
import { DivisionDto } from "@custom-types/division"
import { useFormContext } from "react-hook-form"
import { OrganisationDto } from "@custom-types/organisation"
import { isDivisionUsed } from "@features/administration/organisations/const"

interface IBusinessLinesTableProps {
  data: DivisionDto[]
  setData: (data: DivisionDto[]) => void
}

export default function BusinessLinesTable({
  data = [],
  setData = () => {},
}: IBusinessLinesTableProps) {
  const { getValues } = useFormContext<OrganisationDto>()

  const columns: GridColDef[] = [
    {
      field: "key",
      headerName: "Name",
      headerClassName: "table-header-cell",
      flex: 1,
      editable: true,
      preProcessEditCellProps: (params: GridPreProcessEditCellProps) => {
        const hasError = params.props.value.length < 1
        // n.b. all preProcessEditCellProps are called, so only add if field required
        // processRowUpdate else will return early
        return { ...params.props, error: hasError }
      },
      renderEditCell: (params) => <GridEditInputCell {...params} inputProps={{ maxLength: 30 }} />,
    },
    {
      field: "description",
      headerName: "Description",
      headerClassName: "table-header-cell",
      flex: 1,
      editable: true,
      renderEditCell: (params) => <GridEditInputCell {...params} inputProps={{ maxLength: 150 }} />,
    },
    {
      field: "active",
      headerName: "Active",
      headerClassName: "table-header-cell",
      type: "boolean",
      width: 200,
      editable: true,
    },
  ]

  return (
    <Box className={"business-line-table-container"}>
      <EditableTable
        data={data}
        setData={setData}
        columns={columns}
        emptyObject={{
          id: 0,
          key: "",
          organisation_key: "",
          description: "",
          active: true,
          creator_email: "",
          creation_date: "",
          last_updated: "",
        }}
        fieldToFocus={"name"}
        idPropName={"id"}
        isDeleteRowDisabled={(row) => isDivisionUsed(row.key, getValues("contracts") ?? [])}
        isCellEditable={(params) => {
          const isSavedDivision = params.row.creation_date && params.row.creator_email
          // still not saved, let user modify it
          if (!isSavedDivision) return true

          // active should always be editable
          if (params.field === "active") return true

          // key should not be changed once saved
          if (params.field === "key") return false

          const contracts = getValues("contracts") ?? []
          const divisionKey = params.row?.key ?? ""

          return !isDivisionUsed(divisionKey, contracts)
        }}
      />
    </Box>
  )
}
